import './faq/faq.js';
import '../css/styles.css';

import { initCategories } from './furniture/categories.js';
import { initProducts } from './furniture/furniture-list.js';
import { initFurnitureModal } from './modals/furniture-modal.js';
import { initOrderModal } from './modals/order-modal.js';

import { initFeedback } from './feedback/feedback.js';
// Імпортуємо обидві функції з одного файлу header.js
import { initHeader, initSmoothScroll } from './header/header.js';

async function initApp() {
  if (typeof initHeader === 'function') {
    initHeader();
    await initCategories();
    await initProducts();
    initFurnitureModal();
    initOrderModal();
    await initFeedback();
  }

  if (typeof initSmoothScroll === 'function') {
    initSmoothScroll();
  }
}
void initApp();
